import { render } from "./LocationScores.vue?vue&type=template&id=7c09f2bf&ts=true"
import script from "./LocationScores.vue?vue&type=script&lang=ts"
export * from "./LocationScores.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__